<template>
  <input :type="type" min="1" v-model="value" :placeholder="placeholderFormatted" id="time_picker"
         :max="max" @input="$emit('update:value',value)"
         autocomplete="off"/>
</template>

<script>
export default {
  name: 'Input',

  mixins: [],

  props: {
    placeholder: {
      required: false,
      default: false
    },
    type: {
      required: false,
      default: 'number'
    },
    value: { required: false },
    required: {
      required: false,
      default: true
    },
    max: {
      required: false,
      default: 255
    },
  },

  computed: {
    placeholderFormatted() {
      if (!this.required) {
        return this.placeholder;
      }

      return `${this.placeholder}*`;
    }
  }

};
</script>
<style scoped>
#time_picker {
  height: 50px;
  line-height: 50px;
  -webkit-appearance: none;
  @apply bg-cebeo_blue_faded text-left px-10 uppercase flex justify-between items-center shadow-md outline-none  ;
}

#time_picker::placeholder {
  @apply text-cebeo_gray;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
